export default {
  "category.shoes": "Buty",
  "category.hoodies": "Bluzy / Swetry",
  "category.tshirts": "Koszulki",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie / Szorty",
  "category.headwear": "Nakrycia głowy",
  "category.sets": "Zestawy",
  "category.underwear": "Bielizna / Majtki",
  "category.jersey": "Trykot",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne rzeczy",
};